import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaQualificationCriteriaSetContainerModel } from "../../../../../models/aggregates/sfa/SfaQualificationCriteriaSetContainer.model";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { Core2Config } from "../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class SfaQualificationCriteriaSetService extends BaseApiTemplateService<SfaQualificationCriteriaSetContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.SFA_MODULE_PREFIX +
		"qualification-criteria-sets";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"qualification-criteria-sets";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"qualification-criteria-sets";
		this.httpClient = http;
	}
}
